<script setup lang="ts">
import { Patient } from "./helpers";
import MDynamic from "../../../medicus/MDynamic";

// This file is still required for using the patient finder for certain workflows
// where a callback is used on the dialog module to return the selected patient id
// e.g. patient matching on documents/investigation reports or selecting a patient for a task or appointment

//// PROPS
defineProps<{
  onSelect?: (patient: Patient) => void;
}>();
</script>
<template>
  <MDynamic url="/staff/recent-patients" :on-select="onSelect" />
</template>
<style lang="scss"></style>
